import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';
import { bundleTypeEnum } from '@/constants/bundle.js';

export const apiRetrieveBundles = () => apiRequest({
  url: 'api/getStoreItems',
  method: 'GET',
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!Array.isArray(responseData)) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  const groupedData = responseData.reduce((acc, bundle) => {
    const __bundle = { ...bundle, __bundleType: '' };

    if (bundle.jokers > 0) {
      __bundle.__bundleType = bundleTypeEnum.JOKERS;
      acc[bundleTypeEnum.JOKERS].push(__bundle);
    } else if (bundle.noOfGames > 0) {
      __bundle.__bundleType = bundleTypeEnum.GAMES;
      acc[bundleTypeEnum.GAMES].push(__bundle);
    }

    return acc;
  }, { [bundleTypeEnum.GAMES]: [], [bundleTypeEnum.JOKERS]: [] });

  return { groupedData };
});

export const apiRequestPinForBundlePurchase = ({ payload }) => apiRequest({
  url: 'api/getPin',
  method: 'POST',
  data: payload,
}).then((response) => {
  return { responseEnum: response?.data?.responseEnum };
}).catch(() => ({ responseEnum: '' }));

export const apiPurchaseBundle = ({ payload }) => apiRequest({
  url: 'api/charge',
  method: 'POST',
  data: payload,
}).then((response) => {
  return { responseEnum: response?.data?.responseEnum };
}).catch(() => ({ responseEnum: '' }));
